import { render, staticRenderFns } from "./BankAccountGrid.vue?vue&type=template&id=53769b3c"
import script from "./BankAccountGrid.vue?vue&type=script&lang=js"
export * from "./BankAccountGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports